import React from "react"
import CAppComponent from "../../../../../candidate/app/components/capp-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index";

class StarsInput extends CAppComponent {
    setValue(value) {
        const { disabled, onChange } = this.props;
        if (!disabled && onChange) {
            onChange(value);
        }
    }

    render() {
        const { count, value, onChange, disabled } = this.props;
        const array = [...Array(count).keys()];

        return (
            <div className={`stars-input ${this.props.className || (disabled ? 'text-gray disabled' : 'text-gasnet-green')}`}>
                {
                    array.map((index) => {
                        return (<span key={index} onClick={() => { this.setValue(index+1) }}><FontAwesomeIcon icon={( value > index ? ['fas', 'star'] : ['far', 'star']  )}/></span>);
                    })
                }
            </div>
        )
    }
}

export default StarsInput;
